module.exports = __webpack_public_path__ + "static/media/branding-img22.6632c437.jpg";